export class WorkTypes {
    static Journal = '1ae04722-cc3d-44e5-a672-cdf720f6f3c8';
}

export class EdKinds {
    static Journal = 'af03306e-6781-46c6-825d-28147c0712a5';
}

/* ЖК */
export class ResidentalComplexes {
    /*  Holland Park */
    static HollandPark = '1372f972-e4c8-4fb5-9ead-2b0506ca99ed';
}